import {
  OAUTH_APPLICATION_INIT,
  OAUTH_APPLICATION_SHOW_ID_SECRET_MODAL,
  OAUTH_APPLICATION_HIDE_ID_SECRET_MODAL,
  OAUTH_APPLICATION_SUBMIT_ACTION,
  OAUTH_APPLICATION_SET_FORM_STATE
} from '../../actions/oauthApplication/constants'

const initialState = {
  app: {},
  categories: [],
  scopes: [],
  showIDSecretModal: false,
  submitAction: '',
  formState: 'credentials'
}

export default function reducer (state = initialState, action) {
  const {payload} = action

  switch (action.type) {
    case OAUTH_APPLICATION_INIT:
      return {
        ...state,
        app: payload.app,
        categories: payload.categories,
        scopes: payload.scopes
      }
    case OAUTH_APPLICATION_SHOW_ID_SECRET_MODAL:
      return {...state, showIDSecretModal: true}
    case OAUTH_APPLICATION_HIDE_ID_SECRET_MODAL:
      return {...state, showIDSecretModal: true}
    case OAUTH_APPLICATION_SUBMIT_ACTION:
      return {...state, submitAction: payload.action}
    case OAUTH_APPLICATION_SET_FORM_STATE:
      return {...state, formState: payload.state}
    default:
      return {...state}
  }
}



// WEBPACK FOOTER //
// app/javascript/components/reducers/oauthApplication/oauthApplication.js